module.exports = {"130181100":"辛集镇","130181101":"旧城镇","130181102":"张古庄镇","130181103":"位伯镇","130181104":"新垒头镇","130181105":"新城镇","130181106":"南智邱镇","130181107":"王口镇","130181200":"天宫营乡","130181201":"前营乡","130181202":"马庄乡","130181203":"和睦井乡","130181204":"田家庄乡","130181205":"中里厢乡","130181206":"小辛庄乡","130181500":"辛集经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130181.json
// module id = 163
// module chunks = 0